export default {
    url: process.env.NODE_ENV=="development"?"http://localhost:3000":"https://api.cezfitness-club.com"
}
